import React from "react";
import useMakeScrollable from "custom_hooks/make-scrollable";
import { SurveyItem } from "./SurveyItem";
import { makeStyles } from "@mui/styles";
import { useSurveyDetail } from "./QuestionFlow/QuestionContext";
import { useHistory } from "react-router-dom";

const styles:any = (theme) => ({
  root: {
    fontFamily: "Montserrat",
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#fff",
    paddingBottom: '100px',
  },
});

const useStyles = makeStyles(styles);

export  default function SurveyList() {
  const {surveys} = useSurveyDetail()
  const history = useHistory();
  const routeToSurvey = (survey) => {
    history.push(`/survey_details/${survey.id}`, {survey});
  };

  if (!surveys.length) {
    history.push('/') 
  };

  useMakeScrollable();
  const classes = useStyles();
  return (
    <div className="scrollable">
      <div className="survey">
        {surveys.map((survey, index) => {
          return (
            <SurveyItem 
              survey={survey} 
              key={survey.id} 
              onClick={() => routeToSurvey(survey)} 
            />
          );
        })}
      </div>
    </div>
  );
}
